import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router";
import { REPLACE_AIR } from "../../replace_str_constant";
import { useDispatch, useSelector } from "react-redux";
import {
  clearGameLink,
  startGameLoading,
  storeGameConfig,
} from "../../redux/action/game/gameAction";
import LazyImage from "../Loading/lazyImage";
import { COMMON_WEB_PATH, COMMON_WEB_PATH_JP } from "../../constant";
import useDeviceType from "../../hook/useDeviceType";
import { useTranslation } from "react-i18next";
import { CloseMenu, globalTrigger, notice } from "../../redux/action/action";
import i18next from "i18next";
import { BsTools } from "react-icons/bs";
import {
  AbsoluteCenter,
  Box,
  Flex,
  Icon,
  Image,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { RiUser3Fill } from "react-icons/ri";
import useCheckLogin from "../../hook/useCheckLogin";
import { thisImageNeedDark } from "../../utils/thisImageNeedDark";
import useSound from "../../hook/useSound";
import GameTag from "./GameTag";
import useGames from "../../pages/Game/useGames";
import "./styles.css";
import TooltipWithTouch from "../Common/TooltipWithTouch";
import ToggleFavorite from "../Favorite/ToggleFavorite";

const GameItem = ({
  originProps,
  gameProps,
  specMask,
  isHot,
  itemIndex,
  forceShow,
  liveLayout,
  customHeight,
  hideGameName,
  longLayout, //是否使用長版型
  hiddenTag, //是否隱藏遊戲標籤
  specialBorder, //是否使用特殊邊框
  longImage, // 是否使用長圖
  machineLayout,
  isNormalImage,
}) => {
  const { t } = useTranslation();
  const i18n_common = (key) => t(`common.${key}`);
  const { gameCode, platform, gameName, gameSubType } = gameProps;
  //遊戲ITEM的資料
  const { gameNameEn, game_tags, game_subtype } = originProps;
  const isMobile = useDeviceType() === "Mobile";

  const { isLobby, isLiveLayoutOpen, showLogoInCenter } = liveLayout || {};

  const isHandleAllGame = useSelector((state) => state.isHandleAllGame);
  const onlinePlayer = useSelector((state) => state.isGameOnlinePlayer);
  const { game } = onlinePlayer || {};

  const textColor = useColorModeValue("dark.100", "light.100");
  const itemBg = useColorModeValue("light.100", "dark.250");
  const textBgColor = useColorModeValue("light.200", "dark.100");

  const { isLogin, isMachineUser } = useCheckLogin();
  const displayFavorite = isLogin && !isMachineUser; // 是否顯示收藏按鈕

  const playButtonSound = useSound(); // 進遊戲按鈕音效
  const hoverButtonSound = useSound({
    customSound: "slide_sound",
    volume: 0.3,
  });

  const { allGamePlatform = [] } = isHandleAllGame;

  const dispatch = useDispatch();

  const navigate = useNavigate();
  const location = useLocation();

  const { handlePlayGame } = useGames();

  const getPrevPath = useMemo(() => {
    const path = location.pathname.split("/");
    const currentPathIndex = path.findIndex((item) => item === "game-confirm");

    if (currentPathIndex === -1) return "";

    return `${path.slice(0, currentPathIndex).join("/")}/`;
  }, [location.pathname]);

  const currentPlayer = useMemo(() => {
    return game?.[originProps.gameUid] || 0;
  }, [game]);

  const getPlatformIsMaintain = useMemo(() => {
    const findPlatform = allGamePlatform.find(
      (item) => item.platform === platform,
    );
    /**
     * @param maintenanceStartTime {string}  維護開始時間
     * @param maintenanceEndTime {string}  維護結束時間
     * @param temp_maintenance_start_time {string} 暫時維護開始時間
     * @param temp_maintenance_end_time {string} 暫時維護結束
     * NOTE:會優先用暫時維護時間
     *       如果暫時維護時間不存在，則使用正式維護時間
     * @param isUnderMaintenance {boolean} 是否維護中
     */
    const {
      maintenanceStartTime,
      maintenanceEndTime,
      temp_maintenance_start_time,
      temp_maintenance_end_time,
    } = findPlatform || {};
    const isMaintain = findPlatform?.isUnderMaintenance;
    if (isMaintain) {
      return {
        state: true,
        component: (
          <Box
            position={"absolute"}
            top="50%"
            left="50%"
            transform="translate(-50%,-50%)"
            bg="rgba(0,0,0,0.7)"
            w="100%"
            h={"100%"}
            zIndex="99"
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection={"column"}
            gap="10px"
            color="white"
            className={
              longLayout || machineLayout
                ? "long_layout_box_border_radius  long-octagon-clip"
                : "box_border_radius long-octagon-clip"
            }
          >
            <TooltipWithTouch
              boxClassName={{
                w: "100%",
                h: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
              label={
                <Flex
                  direction={"column"}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <Text as="span">
                    {temp_maintenance_start_time || maintenanceStartTime}
                  </Text>
                  <Text as="span">~</Text>
                  <Text as="span">
                    {temp_maintenance_end_time || maintenanceEndTime}
                  </Text>
                </Flex>
              }
            >
              <Icon as={BsTools} fontSize="30px" />
              <Flex
                direction={"column"}
                alignItems={"center"}
                justifyContent={"center"}
                fontSize="sm"
                fontWeight={"500"}
              >
                <Text as="span">{i18n_common("platformMaintain")}</Text>
              </Flex>
            </TooltipWithTouch>
          </Box>
        ),
      };
    }
  }, [platform, longLayout, machineLayout]);

  const handleEnterGame = () => {
    // 播放按鈕音效
    playButtonSound();
    if (isLiveLayoutOpen && !isLobby && !isLogin) {
      navigate(`${getPrevPath}category/${originProps.game_platform}`);
      return;
    }

    if (getPlatformIsMaintain?.state) return;
    dispatch(storeGameConfig(originProps));
    dispatch(clearGameLink());
    dispatch(CloseMenu());
    dispatch(startGameLoading());

    const game_name = gameNameEn.replace(/ /g, "-");
    const game_platform = originProps.game_platform.replace(/ /g, "-");

    handlePlayGame({
      gameName: game_name,
      gamePlatform: game_platform,
      gameUid: originProps.gameUid,
    });
  };

  return (
    <Flex
      role="group"
      direction={`column`}
      position={`relative`}
      cursor={
        getPlatformIsMaintain?.state && !forceShow ? `not-allowed` : `pointer`
      }
      px={{
        base: isHot ? "" : "",
        md: "",
      }}
      py={{
        base: isHot ? "" : "",
        md: "",
      }}
      transform={machineLayout ? "skewX(-2deg)" : ""}
      // onClick={isMobile ? () => false : handleEnterGame}
      onClick={handleEnterGame}
      onMouseEnter={isMobile ? () => false : hoverButtonSound}
      boxShadow={`base`}
      overflow="hidden"
      my="2px"
      h="100%"
      hover={{
        background: {
          md: getPlatformIsMaintain?.state
            ? `none`
            : specMask
              ? `rgba(0,0,0,0.1)`
              : `brand.500`,
        },
      }}
      p={(isHot || isLiveLayoutOpen) && itemIndex + 1 < 11 ? "" : ""}
    >
      {displayFavorite && (
        <ToggleFavorite
          wrapperClass={{
            position: "absolute",
            top: "0.5em",
            right: "0.5em",
            zIndex: 1000,
          }}
          fontSize="1em"
          customGameUid={originProps.gameUid}
        />
      )}

      {getPlatformIsMaintain?.component}
      {hiddenTag ? null : (
        <GameTag
          isLongLayout={longLayout || machineLayout}
          game_tags_props={game_tags || []}
        />
      )}
      <Box
        position={"absolute"}
        w="100%"
        h="100%"
        top="0px"
        left="0px"
        // bgImage={`url('${COMMON_WEB_PATH}/FlyDragon/game_BFrame2x.webp')`}
        bgImage={
          hideGameName
            ? `url('${COMMON_WEB_PATH}/FlyDragon/game_BFrame_mobile.webp')`
            : {
                base: `url('${COMMON_WEB_PATH}/theOne/gameType/${
                  specialBorder && !longLayout
                    ? `game_item_special_background_blue.png`
                    : `game_item_background.webp`
                }')`,
                sm: `url('${COMMON_WEB_PATH}/theOne/gameType/${
                  specialBorder && !longLayout
                    ? `game_item_special_background_blue.png`
                    : `game_item_background${longLayout ? "_long_" : ""}.webp`
                }')`, // sm 以上使用的圖片
              }
        }
        bgPosition="center"
        bgRepeat="no-repeat"
        bgSize="100%100%"
        zIndex={4}
        onClick={handleEnterGame}
        cursor={"pointer"}
        display={"flex"}
        alignItems={"flex-end"}
        justifyContent={"center"}
        pb="2vw"
      ></Box>
      <Box
        h="100%"
        _groupHover={{
          zIndex: 1,
        }}
        borderRadius={`sm`}
        overflow="hidden"
      >
        {showLogoInCenter ? (
          <>
            <Box
              position="absolute"
              bg="rgba(0,0,0,0.7)"
              w="100%"
              h="100%"
              top="0px"
              left="0px"
              zIndex={1}
            ></Box>
            <AbsoluteCenter top="40%" zIndex={2}>
              <Image
                src={`${COMMON_WEB_PATH}/ds88platformIcon/${thisImageNeedDark(
                  platform,
                  true,
                )}.png`}
                w="140px"
                transform={"scale(1.3)"}
              />
            </AbsoluteCenter>
          </>
        ) : null}
        {currentPlayer > 0 && (
          <Box
            position="absolute"
            right="5px"
            top="5px"
            borderRadius={`full`}
            py="3px"
            px="10px"
            zIndex={2}
            bg={itemBg}
            color={textColor}
            display="flex"
            alignItems={`center`}
            gap="3px"
            fontSize="12px"
          >
            <Icon as={RiUser3Fill} />
            {currentPlayer}
          </Box>
        )}

        <Box
          pt={
            machineLayout
              ? {
                  base: "50vh",
                }
              : customHeight
                ? {
                    base: "162%",
                    md: "162%",
                  }
                : {
                    base: "97%",
                    md: "100%",
                  }
          }
          position="relative"
          borderRadius={`8px`}
          overflow="hidden"
          h="100%"
        >
          <Box
            zIndex={2}
            position="absolute"
            top="0px"
            left="0px"
            height="100%"
            width="100%"
            // overflow="hidden"
            isolation={`isolate`}
          >
            <Box
              height={"100%"}
              width={"100%"}
              px={longLayout || machineLayout ? "3px" : "3px"}
            >
              <Box className={"long-octagon-clip"}>
                <LazyImage
                  //預設嘗試載入gif  如果gif不存在或載入失敗，自動切換到 webp
                  src={
                    longLayout && longImage
                      ? `${COMMON_WEB_PATH_JP}/game-icon-ds88/en/${platform}/${REPLACE_AIR(
                          gameCode,
                        )}_long.webp`
                      : `${COMMON_WEB_PATH_JP}/game-icon-ds88/${
                          i18next.language
                        }/${platform}/${REPLACE_AIR(gameCode)}.gif`
                  }
                  alt={gameNameEn}
                  closeInverted
                  isNormalImage={isNormalImage}
                  className={`w-full h-full cut-corners-mask p-[6px]`}
                  onError={(e) => {
                    const img = e.target;
                    const currentSrc = img.src;
                    const lang = i18next.language;
                    const gameCodeReplaced = REPLACE_AIR(gameCode);

                    if (
                      lang !== "en" &&
                      currentSrc.endsWith(
                        `${lang}/${platform}/${gameCodeReplaced}.gif`,
                      )
                    ) {
                      img.src = `${COMMON_WEB_PATH_JP}/game-icon-ds88/${lang}/${platform}/${gameCodeReplaced}.webp`;
                    } else if (
                      lang !== "en" &&
                      currentSrc.endsWith(
                        `${lang}/${platform}/${gameCodeReplaced}.webp`,
                      )
                    ) {
                      img.src = `${COMMON_WEB_PATH_JP}/game-icon-ds88/en/${platform}/${gameCodeReplaced}.gif`;
                    } else if (
                      currentSrc.endsWith(
                        `en/${platform}/${gameCodeReplaced}.gif`,
                      )
                    ) {
                      img.src = `${COMMON_WEB_PATH_JP}/game-icon-ds88/en/${platform}/${gameCodeReplaced}.webp`;
                    } else {
                      img.onerror = null;
                    }
                  }}
                />
              </Box>
            </Box>
            <Box
              className={"long-octagon-clip"}
              position={`absolute`}
              top="0%"
              left="0%"
              height={"100%"}
              width={"100%"}
              display={{
                base: "none",
                md: "flex",
              }}
              alignItems={`flex-end`}
              justifyContent={`center`}
              opacity={0}
              // className="transition duration-300"
              _groupHover={{
                opacity: 1,
                background: "rgba(0,0,0,0.5)",
              }}
              bgImage={{
                base: `url('${COMMON_WEB_PATH}/now888/gameItem/${
                  specialBorder && !longLayout
                    ? `game_item_special_background_blue.png`
                    : `game_item_background_blue_.webp`
                }')`,
                sm: `url('${COMMON_WEB_PATH}/theOne/gameType/${
                  specialBorder && !longLayout
                    ? `game_item_special_background_active_blue.png`
                    : `game_item_background${longLayout ? "_long" : ""}.webp`
                }')`, // sm 以上使用的圖片
              }}
              bgRepeat={`no-repeat`}
              bgSize="100% 100%"
              bgPos="center"
            >
              <Image
                onClick={handleEnterGame}
                cursor={"pointer"}
                src={`${COMMON_WEB_PATH}/theOne/gameType/play_button.png`}
                mb="18%"
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Flex>
  );
};

export default GameItem;
